import axios from 'axios'
import md5 from "js-md5"
import { isDev } from '@/utils/config.js'

const baseURL = isDev ? '/api' : ''

console.log(baseURL)

let ts = Date.now()
const secretKey = 'dh_vnu7ncxfz'
const channelId = '100002' //  900003
const chang = 'en_US'

const service = axios.create({
  baseURL,
  headers: {
    channelId,
    ts,
    sign: md5(channelId + secretKey + ts),
    'Accept-Language': chang,
  },
  timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    // 请求错误处理
    console.log('Request Error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 响应后处理
    if (response.status === 200 && response.data.code === '0000') {
      return Promise.resolve(response.data.data)
    } else {
      return Promise.reject(response.data)
    }
  },
  error => {
    console.log('Response Error:', error)
    return Promise.reject(error)
  }
)

export default service
